const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  data() {
    return {
        btnExport:false,
        btnPrint:false
    }
},
  methods: {
    // 批量导出
    batchExport() {
      if (this.searchForm.ids.length == 0) {
        this.$message.warning('请勾选导出的数据')
      } else {
        this.getPdf('export',this.searchForm.ids)
      }
    },
    // 批量打印
    batchPrint(){
      if (this.searchForm.ids.length == 0) {
        this.$message.warning('请勾选打印的数据')
      } else {
        this.getPdf('print',this.searchForm.ids)
      }
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    // 获取pdf
    getPdf(type,id = this.$route.query.id) {
      this.loading = true; // 开始加载时设置 loading 为 true
      if(type==='print'){
        this.btnPrint = true
      }else if(type==='export'){
        this.btnExport = true
      }
      let ids 
      if(typeof id === 'string'){
        ids = [id]
      }else if(typeof id === 'object'){
        ids = id
      }
      this.$api.workflowPdf(ids).then((res) => {
        if (res.code === 0) {
          // https://testapi.5eck.cn/oa/workflow/pdf/view?path=pdf_20250410_115852_b59ed009/merged.pdf
          let fileUrl = baseURL +'/oa/workflow/pdf/view?path='+ res.data
          fetch(fileUrl).then(response => {
            if (!response.ok) throw new Error('网络响应异常');
            return response.blob(); // 将响应数据转为 Blob
          }).then(blob => {
            // 创建 Blob URL 并触发下载
            const blobUrl = window.URL.createObjectURL(blob);
            if(type==='print'){
              this.urlToPrint(blobUrl)
            }else if(type==='export'){
              this.urlToDownload(blobUrl)
            }
          }).catch(error => {
            console.error('失败:', error);
          });
        }
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false; // 无论成功或失败，设置 loading 为 false
        this.btnPrint = false;
        this.btnExport = false;
      });
    },
     // 文件去打印
    urlToPrint(blobUrl) {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow.print();
      };
      iframe.onafterprint = () => {
        document.body.removeChild(iframe);
      };
    },
    // 文件去下载
    urlToDownload(blobUrl) {
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = `document_${Date.now()}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl); // 释放资源
    },
  }
}
